import { HttpParams, HttpRequest,  HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { Video } from '../models/video.model';
import { ActivatedRoute } from '@angular/router';

import 'rxjs/Rx';

import { APP_CONFIG } from '../app.config';

@Injectable()
export class VideoService {
  videosChanged = new Subject<Video[]>();
  videoChanged = new Subject<Video>();
  videoOperation = new Subject<Video>();

  private videos: Video[] = [];

  constructor(@Inject(APP_CONFIG) private appConfig, private httpClient: HttpClient) {}

  setVideos(videos: Video[]) {
    this.videos = videos;
    this.videosChanged.next(this.videos.slice());
  }

  getVideos() {
    return this.videos.slice();
  }

  getIdIndex(id: number) {
    return this.videos.findIndex(c => c.ID === id);
  }

  httpGetVideos(params: any = {}, columns: string = '', order: string = '') {
    let httpParams = new HttpParams();

    if ( columns ) {
      httpParams = httpParams.append('select', columns);
    }
    if ( order ) {
      httpParams = httpParams.append('order', order);
    }

    for (let p of Object.keys(params)) {
      httpParams = httpParams.append(p, params[p]);
    }

    const req = new HttpRequest(
      'GET',
      this.appConfig.API_ENDPOINT + '/videos',
      {
        params: httpParams
      }
    );

    return this.httpClient.request(
      req
    )
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: Video[]) => {
        this.setVideos(response);
      }
    );
  }

  httpGetVideo(id: number) {

    const req = new HttpRequest(
      'GET',
      this.appConfig.API_ENDPOINT + '/videos/' + id,
    );

    return this.httpClient.request(
      req
    )
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: Video) => {
        this.videoChanged.next(response);
      }
    );
  }

  httpPostVideo(data: Video) {
    const req = new HttpRequest(
      'POST',
      this.appConfig.API_ENDPOINT + '/videos',
      data
    );

    return this.httpClient.request<any>(req)
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.videoOperation.next(response);
      }
    );
  }

  httpPutVideo(id: number, data: Video) {
    const req = new HttpRequest(
      'PUT',
      this.appConfig.API_ENDPOINT + '/videos/' + id,
      data
    );

    return this.httpClient.request<any>(req)
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.videoOperation.next(response);
      }
    );
  }

  httpDeleteVideo(id: number) {
    const req = new HttpRequest(
      'DELETE',
      this.appConfig.API_ENDPOINT + '/videos/' + id
    );

    return this.httpClient.request<any>(req)
    .subscribe(
      (response: any) => {
        this.httpGetVideos();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/video.service.ts